import { BaseOwnerEntity } from "../entity/baseOwnerEntity";

export class Address extends BaseOwnerEntity {
  id?: number;
  customerId?: number;
  addressTypeId?: number;
  title?: string;
  countryId?: number;
  countryName?: string;
  cityId?: number;
  cityName?: string;
  subProvinceId?: number;
  subProvinceName?: string;
  districtId?: number;
  districtName?: string;
  description?: string;
  siteName?: string;
  buildingName?: string;
  doorNum?: string;
  longitude?: number;
  latitude?: number;
  isLocationValid?: boolean;
  status?: number;
  categoryType?: string;
}
